import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';
import { getDepartments, processDepartments } from '../../../actions/apiGetInfo';
import {
	setCurrentTab,
	setCurrentDefaultProfile,
} from '../../../actions/apiSetInfo';
import {
	activeEditVehicleColumn,
	activeEditDepartment,
} from '../../../actions/lookups';

const AddColumnToTabRibbon = ({ vehicle_column, tab }) => {
	const [errors, setErrors] = useState({ addDepartmentError: false });
	const dispatch = useDispatch();

	const installation = useSelector((state) => state.settings_dealerships.installation);
	const departments = useSelector((state) => state.settings_departments.original_departments);
	const input_types = useSelector((state) => state.settings_departments.input_types);
	const edit_department = useSelector((state) => state.settings_admin.edit_department);
	const vehicle_columns = useSelector((state) => state.settings_departments.vehicle_columns);

	const addNewTabProperty = () => {
		const id = tab.id;
		const errorType = 'addNewTabProperty';
		console.log(vehicle_column);
		const data = {
			tab_id: id,
			vehicle_column_id: vehicle_column.original.vehicle_column_id[0],
			dealership: installation.subdomain,
			name: vehicle_column.original.name[0],
			order: '99',
		};

		dispatch(addTabProperty(data, errorType));
	};

	return (
		<button className="btn btn-sm btn-success" onClick={addNewTabProperty}>
			Add to {tab.name}
		</button>
	);
};

export default AddColumnToTabRibbon;